<template>
	<div class="top">
		<el-row>
			<el-col :span="18" :offset="3">
				<div class="top_list">
					<!-- logo -->
					<img src="../assets/logo.png" />
					<ul>
						<li :class="{ 'top_online': type=='index' }" @click="goTab('index')">
							首页
						</li>
						<li :class="{ 'top_online': type=='We' }" @click="goTab('We')">
							关于我们
						</li>
						<li :class="{ 'top_online': type=='Develop' }" @click="goTab('Develop')">
							研发领域
						</li>
						<li :class="{ 'top_online': type=='Vision' }" @click="goTab('Vision')">
							公司愿景
						</li>
						<li :class="{ 'top_online': type=='Address' }" @click="goTab('Address')">
							联系我们
						</li>
					</ul>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		computed:{
			type(){
				let num = 'index';
				if (typeof(this.$route.query.map) == 'undefined') {
					num = 'index'
				}else{
					num = this.$route.query.map
				}
				return num;
			}
		},
		mounted() {
console.log(this.$route.query.map)
		},
		methods: {
			goTab(data){
				this.$router.push({path:'/', query: { map: data }})
				console.log(this.$route.query.map)
			}
		},
	}
</script>

<style lang="scss" scoped="scoped">
	.top{
		width: 100%;
		height: auto;
		.top_list{
			// width: 1200px;
			height: 92px;
			background-color: rgba(255,255,255,.5);
			margin: 0 auto;
			margin-top: 40px;
			border-radius: 5px;
		}
		img{
			margin-left: 14px;
			float: left;
			margin-right: 130px;
		}
		ul{
			display: inline;
			li{
				width: 80px;
				height: 92px;
				text-align: center;
				line-height: 92px;
				float: left;
				font-size: 18px;
				margin-right: 70px;
				cursor:pointer;
			}
			.top_online{
				color: #1388F4;
				border-bottom: 2px solid #1388F4;
			}
			li:hover{
				color: #1388F4;
			}
		}
	}
</style>
